// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"3090":"6b9b164820872c57","4995":"f3fe56af388f9500","6855":"cbaf00fd8d85f70f","8841":"ebfcee6216148a8f"}[chunkId] + ".css";
};